export const purchaseOrder = {
  purchaseOrder: "Purchase Order",
  textPoEmpty: "You don’t have any Purchase Order to show yet!",
  poRespondTitle: "Response to Purchase Order",
  confirmMessage: "Are you sure you want to {{acceptance}} this purchase order",
  poName: "PO name",
  poNumber: "PO Number",
  orderNumber: "Order number",
  amount: "Amount",
  status: "Status",
  createdAt: "Sent at",
  downloadPo: "Download PO",
  poSoftDeletedTooltip:
    "This purchase order is already deleted or terminated.",
  downloadAll: "Download All",
  downloadInProgressMessage:
    "Download in progress. Expected completion time may vary.",
};
